<template>
  <div class="user-menu-wrapper">
    <!-- 未登录：登录按钮 -->
    <el-button
      v-if="!userLoggedIn"
      class="header-btn login-btn"
      type="text"
      @click="$emit('open-login')"
    >
      <el-icon><User /></el-icon>
    </el-button>
    
    <!-- 已登录：用户下拉菜单 -->
    <div
      v-else
      class="user-dropdown"
    >
      <div
        class="user-info"
        @click="toggleUserMenu"
      >
        <img
          :src="userAvatar"
          alt="用户头像"
          class="user-avatar"
        >
      </div>
      <!-- 自定义下拉菜单 -->
      <div
        v-if="showUserMenu"
        class="user-menu-panel"
        @click.stop
      >
        <!-- 顶部用户信息区域 -->
        <div class="user-menu-header">
          <div class="user-name">
            <div class="user-name-side left">
              <img
                v-if="$auth.hasPersonalType()"
                src="@/assets/icons/personal.svg"
                alt="个人"
                class="user-type-icon"
              >
              <img
                v-else-if="$auth.isChannel()"
                src="@/assets/icons/channelIcons.svg"
                alt="渠道企业"
                class="user-type-icon"
              >
              <img
                v-else-if="$auth.isOrganization()"
                src="@/assets/icons/organizationIcons.svg"
                alt="机构企业"
                class="user-type-icon"
              >
              <img
                v-else
                src="@/assets/icons/enterprise.svg"
                alt="普通企业"
                class="user-type-icon"
              >
            </div>
            <div class="user-name-text">
              {{ mainBodyName }}
            </div>
            <div class="user-name-side right" />
          </div>
          <div class="user-role-info">
            <span
              v-if="$auth.hasEnterpriseAccount()"
              class="main-body-operate-name"
            >{{ mainBodyOperateName }}</span>
            <div
              v-if="$auth.getMainBodyRoleName()"
              class="main-body-role-name"
            >
              <span
                class="role-name-value"
                v-html="formatMessageContent($auth.getMainBodyRoleName())"
              />
            </div>
          </div>
 
          <!-- <el-button
            class="upgrade-btn"
            type="primary"
            @click="handleUpgrade"
          >
            升级/续费 大会员
          </el-button> -->
        </div>
        
        <!-- 中间菜单列表 -->
        <div class="user-menu-list">
          <div
            class="menu-item"
            :class="{ active: activeMenuItem === 'profile' }"
            @click="handleMenuClick('profile')"
          >
            <span>个人中心</span>
            <span
              v-if="$auth.isAssociationMember()"
              class="menu-item-member-tag"
            >
              <span class="member-tag-text">{{ $auth.getMainBody()?.haveMemberUnitTypeLabel }}</span>
              <img
                src="@/assets/icons/plus-vip.png"
                alt=""
                class="member-tag-crown"
              >
            </span>
          </div>
          <!-- <div class="menu-item" :class="{ active: activeMenuItem === 'message' }" @click="handleMenuClick('message')">消息通知</div> -->
          <!-- <div
            class="menu-item"
            :class="{ active: activeMenuItem === 'order' }"
            @click="handleMenuClick('order')"
          >
            订单记录中心
          </div> -->
          <div
            class="menu-item"
            :class="{ active: activeMenuItem === 'rights' }"
            @click="handleMenuClick('rights')"
          >
            我的权益
          </div>
          <!-- <div class="menu-item" :class="{ active: activeMenuItem === 'identity' }" @click="handleMenuClick('identity')">身份认证</div> -->
          <div
            v-if="canShowEnterpriseAdmin"
            class="menu-item"
            :class="{ active: activeMenuItem === 'enterpriseAdmin' }"
            @click="handleMenuClick('enterpriseAdmin')"
          >
            企业管理员
          </div>
          <!-- <div
            class="menu-item"
            :class="{ active: activeMenuItem === 'invite' }"
            @click="handleMenuClick('invite')"
          >
            邀请好友,领取免费权益
          </div> -->
        </div>
        
        <!-- 底部操作按钮 -->
        <div class="user-menu-footer">
          <el-button
            class="logout-btn"
            @click="handleLogout"
          >
            退出登录
          </el-button>
          <el-button
            v-if="canShowSwitchUserButton"
            class="switch-user-btn"
            type="primary"
            @click="handleSwitchUser"
          >
            {{ switchUserButtonText }}
          </el-button>
        </div>
      </div>
      <!-- 遮罩层，点击关闭菜单 -->
      <div
        v-if="showUserMenu"
        class="user-menu-overlay"
        @click="closeUserMenu"
      />
    </div>

    <!-- 选择管理用户 -->
    <SelectIdentityDialog
      v-model:visible="identityDialogVisible"
      mode="all"
      @success="handleIdentitySwitchSuccess"
    />
  </div>
</template>

<script>
import { ElMessage, ElLoading } from 'element-plus'
import { logout, switchUser } from '@/api/login'
import SelectIdentityDialog from '@/components/SelectIdentityDialog/index.vue'
import { formatMessageContent, showEnhancedConfirmDialog } from '@/utils/messageUtils'

export default {
  name: 'UserMenu',
  components: {
    SelectIdentityDialog
  },
  data() {
    return {
      showUserMenu: false,
      activeMenuItem: '',
      currentAvatarUrl: null,
      identityDialogVisible: false
    }
  },
  computed: {
    userLoggedIn() {
      return this.$auth.isLoggedIn()
    },
    mainBodyName() {
      const user = this.$auth.getMainBody()
      return (user && user.mainBodyName)
    },
    userAvatar() {
      if (this.currentAvatarUrl) {
        return this.currentAvatarUrl
      }
      const user = this.$auth.getMainBody()
      const avatar = user && user.mainBodyAvatar
      return avatar || require('@/assets/images/userDefaultAvatar.jpg')
    },
    mainBodyOperateName() {
      const user = this.$auth.getMainBody()
      return user && user.mainBodyOperateName || ''
    },
    canShowEnterpriseAdmin() {
      return this.$auth.hasEnterpriseType()
    },
    canShowSwitchUserButton() {
      const user = this.$auth.getMainBody()
      if (!user) return false

      // 账号密码登录不允许切换身份
      if (!this.$auth.getCanSwitchIdentity()) {
        // 未写入 canSwitchIdentity
        if (this.$auth.hasEnterpriseType()) {
          return user.adminUserId != null
        }
        if (this.$auth.hasPersonalType()) {
          return !!user.personalUserHasAdminIdentity
        }
        return false
      }

      // 可切换会话：当前为企业身份可切回个人；个人身份需有企业管理员身份才显示
      if (this.$auth.hasEnterpriseType()) {
        return true
      }
      return !!user.personalUserHasAdminIdentity
    },
    switchUserButtonText() {
      if (this.$auth.getCanSwitchIdentity()) {
        return '切换身份'
      }
      if (this.$auth.hasEnterpriseType()) {
        return '切换个人用户'
      }
      return '切换企业账户'
    },
  },
  watch: {
    '$route'() {
      this.updateActiveMenuItem()
    },
    userLoggedIn(newVal) {
      if (newVal) {
        this.initAvatarUrl()
      } else {
        this.currentAvatarUrl = null
      }
    }
  },
  mounted() {
    this.initAvatarUrl()
    this.updateActiveMenuItem()
    window.addEventListener('avatar-updated', this.handleAvatarUpdated)
  },
  beforeUnmount() {
    window.removeEventListener('avatar-updated', this.handleAvatarUpdated)
  },
  methods: {
    formatMessageContent,
    showEnhancedConfirmDialog,
    initAvatarUrl() {
      const user = this.$auth.getMainBody()
      if (user && user.mainBodyAvatar) {
        this.currentAvatarUrl = user.mainBodyAvatar
      }
    },
    handleAvatarUpdated(event) {
      if (event && event.detail && event.detail.avatarUrl) {
        this.currentAvatarUrl = event.detail.avatarUrl
      }
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu
      if (this.showUserMenu) {
        this.$emit('menu-toggle', 'user')
      }
    },
    closeUserMenu() {
      this.showUserMenu = false
    },
    handleMenuClick(menuKey) {
      this.activeMenuItem = menuKey
      this.closeUserMenu()
      
      switch (menuKey) {
        case 'profile':
          if (this.$auth.hasPersonalType()) {
            this.$router.push('/user-center/account/personal-auth')
          } else {
            this.$router.push('/user-center/account/enterprise-auth')
          }
          break
        case 'message':
          this.$router.push('/user-center/message')
          break
        case 'order':
          this.$router.push('/user-center/order')
          break
        case 'rights':
          this.$router.push('/user-center/rights/free-rights')
          break
        case 'identity':
          if (this.$auth.hasPersonalType()) {
            this.$router.push('/user-center/account/personal-auth')
          } else {
            this.$router.push('/user-center/account/enterprise-auth')
          }
          break
        case 'enterpriseAdmin':
          this.$router.push('/user-center/account/management')
          break
        case 'invite':
          this.$router.push('/user-center/rights/invite-user')
          break
      }
    },
    handleUpgrade() {
      this.closeUserMenu()
      this.$router.push('/user-center/rights/platform-vip')
    },
    async handleSwitchUser() {
      this.closeUserMenu()
      // 手机号/扫码登录会话：弹出身份选择框
      if (this.$auth.getCanSwitchIdentity()) {
        this.identityDialogVisible = true
        return
      }

      // 旧逻辑兼容：一对一切换
      try {
        const confirmed = await this.showEnhancedConfirmDialog(
          '确定要切换用户身份吗？',
          '提示',
          '确定切换',
          '取消'
        )
        if (!confirmed) return

        const loading = ElLoading.service({
          lock: true,
          text: '正在切换用户身份...',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        try {
          const response = await switchUser()
          if (response && response.code === 200) {
            const newToken = response.data.token
            this.$auth.clearAuth()
            this.$auth.setToken(newToken)
            if (response.data.canSwitchIdentity !== undefined) {
              this.$auth.setCanSwitchIdentity(!!response.data.canSwitchIdentity)
            }
            await this.$auth.refreshMainBody()
            loading.close()
            ElMessage.success('切换成功！')
            setTimeout(() => {
              window.location.href = '/'
            }, 1500)
          }
        } catch (error) {
          loading.close()
          console.error('切换用户失败:', error)
        }
      } catch (error) {
        console.error('切换用户操作异常:', error)
      }
    },
    handleIdentitySwitchSuccess() {
      ElMessage.success('切换成功！')
      setTimeout(() => {
        window.location.href = '/'
      }, 1000)
    },
    async handleLogout() {
      this.closeUserMenu()
      try {
        const confirmed = await this.showEnhancedConfirmDialog(
          '确定要退出登录吗？',
          '提示',
          '确认退出',
          '取消'
        )
        if (!confirmed) return
        
        const loading = ElLoading.service({
          lock: true,
          text: '正在退出登录...',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        try {
          await logout()
          this.$auth.clearAuth()
          this.$emit('logout')
          setTimeout(() => {
            loading.close()
            ElMessage.success('已退出登录')
          }, 1000)
          setTimeout(() => {
            this.$router.push('/').then(() => {
              window.location.reload()
            }).catch(() => {
              window.location.reload()
            })
          }, 1500)
        } catch (error) {
          console.error('退出登录错误:', error)
          loading.close()
          ElMessage.error('退出登录失败')
        }
      } catch (error) {
        console.error('退出登录操作异常:', error)
      }
    },
    updateActiveMenuItem() {
      const route = this.$route
      if (route.path === '/user-center') {
        const query = route.query
        if (query.tab === 'rights') {
          this.activeMenuItem = 'rights'
        } else if (query.tab === 'order') {
          this.activeMenuItem = 'order'
        } else if (query.tab === 'message') {
          this.activeMenuItem = 'message'
        } else {
          this.activeMenuItem = ''
        }
      } else {
        this.activeMenuItem = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-menu-wrapper {
  display: flex;
  align-items: center;
}

.header-btn {
  font-size: 14px;
  border-radius: 9999px;
  transition: all 0.3s;
  font-weight: bold;

  &.login-btn {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 50%;
    color: #333333;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      color: #1563e8;
      background-color: #f5f7fa;
    }

    i {
      margin: 0;
    }
  }
}

.user-dropdown {
  position: relative;
  
  .user-info {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s;
    
    .user-avatar {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #e4e7ed;
      transition: all 0.3s;
      
      &:hover {
        border-color: #0d63f3;
        transform: scale(1.05);
      }
    }
  }
  
  // 用户菜单面板
  .user-menu-panel {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    width: 288px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    overflow: hidden;
    
    // 顶部用户信息区域
    .user-menu-header {
      padding: 13px;
      border-bottom: 1px solid #f0f0f0;
      text-align: center;
      
      .user-name {
        margin-bottom: 2px;
        line-height: 1.5;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        
        .user-name-side {
          flex: 1;
          display: flex;
          align-items: center;
          
          &.left {
            justify-content: flex-end;
            padding-right: 8px;
          }
          &.right {
            justify-content: flex-start;
          }
        }

        .user-name-text {
          font-size: 18px;
          font-weight: 600;
          color: #000000;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 180px;
          flex: 0 0 auto;
        }
        
        .user-type-icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
      
      .user-role-info {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        gap: 4px;

        .main-body-operate-name {
          font-weight: 400;
          font-size: 13px;
          color: #696969;
          text-align: center;
        }
        
        .main-body-role-name {
          font-size: 14px;
          color: #666666;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          flex-wrap: wrap;
          
          .role-name-value {
            :deep(.role-name-label) {
              color: #fff;
              padding: 2px 8px;
              border-radius: 3px;
              font-size: 12px;
              margin-left: 5px;
              display: inline-block;
              line-height: 1.5;
            }
          }
          
          .unbind-btn {
            color: #ff4949;
            font-size: 12px;
            padding: 0;
            height: auto;
            min-height: auto;
            
            &:hover {
              color: #ff7875;
            }
          }
        }
      }
      .upgrade-btn {
        width: 180px;
        height: 44px;
        border-radius: 19px;
        font-size: 15px;
        font-weight: 500;
        background: #0d63f3;
        border: none;
        padding: 0;
        
        &:hover {
          background: #3d7ef5;
        }
      }
    }
    
    // 中间菜单列表
    .user-menu-list {
      padding: 4px 0;
      
      .menu-item {
        padding: 12px 20px;
        font-size: 14px;
        font-weight: 600;
        color: #000000;
        cursor: pointer;
        transition: all 0.2s;
        line-height: 1.5;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          background-color: #ecf5ff;
          color: #0d63f3;

          .member-tag-text {
            color: #CAA661;
          }
        }
      }

      .menu-item-member-tag {
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }

      .member-tag-text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #CAA661;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .member-tag-crown {
        width: 14px;
        height: 14px;
        object-fit: contain;
        flex-shrink: 0;
      }
    }
    
    // 底部操作按钮
    .user-menu-footer {
      padding: 16px 20px;
      border-top: 1px solid #f0f0f0;
      display: flex;
      gap: 12px;
      
      .logout-btn {
        flex: 1;
        height: 36px;
        border-radius: 8px;
        background: #ffffff;
        color: #666666;
        border: 1px solid #d9d9d9;
        font-size: 14px;
        
        &:hover {
          background: #f5f7fa;
          border-color: #0d63f3;
          color: #0d63f3;
        }
      }
      
      .switch-user-btn {
        flex: 1;
        height: 36px;
        border-radius: 8px;
        background: #0d63f3;
        border: none;
        font-size: 14px;
        
        &:hover {
          background: #3d7ef5;
        }
      }
    }
  }
  
  // 遮罩层
  .user-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: transparent;
  }
}

// 移动端适配
@media (max-width: 768px) {
  .header-btn {
    &.login-btn {
      width: 32px;
      height: 32px;
      font-size: 18px;
    }
  }

  .user-dropdown {
    .user-info {
      .user-avatar {
        width: 32px;
        height: 32px;
      }
    }

    .user-menu-panel {
      position: fixed;
      top: auto;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      max-height: 70vh;
      overflow-y: auto;
      border-radius: 16px 16px 0 0;

      .user-menu-header {
        padding: 16px;
        position: sticky;
        top: 0;
        background: #ffffff;
        z-index: 1;

        .user-name {
          font-size: 16px;
        }

        .upgrade-btn {
          width: 100%;
          margin-top: 12px;
        }
      }

      .user-menu-list {
        .menu-item {
          padding: 14px 20px;
          font-size: 15px;
        }
      }

      .user-menu-footer {
        padding: 12px 16px;
        flex-direction: column;
        gap: 10px;

        .logout-btn,
        .switch-user-btn {
          width: 100%;
          min-height: 40px;
          height: auto;
          margin: 0;
          margin-left: 0;
          padding: 8px 12px;
          box-sizing: border-box;
          white-space: normal;
          line-height: 1.35;
          word-break: break-word;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .user-dropdown {
    .user-info {
      .user-avatar {
        width: 28px;
        height: 28px;
      }
    }
  }
}
</style>
